<template>

    <div class="box box-info">
        <div class="box-header with-border" v-if="!showFilters">
            <div v-if="filters.functional_area_id != null && filters.functional_area_id.length">Área: <strong>{{functional_area_name}}</strong></div>
            <div v-if="filters.roster_id != null && filters.roster_id.length">Nómina: <strong>{{roster_name}}</strong></div>
            <div v-if="filters.labor_agreement_id != null && filters.labor_agreement_id.length">Acuerdo Laboral: <strong>{{labor_agreement_name}}</strong></div>
            <div v-if="filters.filter">Empleado: <strong>{{filters.filter}}</strong></div>
            <div v-if="filters.date_from">Fechas: <strong>{{filters.date_from}} a {{filters.date_to}}</strong></div>
			<div class="box-tools pull-right">
	            <a href="#" @click.prevent="showFilters = true">[Cambiar filtros]</a>
	        </div>
        </div>


		<div class="box-header with-border" v-if="showFilters">
			<h3 class="box-title">Filtrar</h3>

			<div class="box-tools pull-right">
				<button type="button" class="btn btn-box-tool" @click="showFilters = false" data-original-title="Cancelar">
				<i class="fa fa-times"></i></button>
			</div>
			<div class="box-body">
				<el-form :inline="true" ref="filtersForm" :model="filters" class="demo-form-inline">
					<el-row>
                        <el-col :span="8">
                            <el-form-item label="Área" label-width="120px">
                                <el-select multiple v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                                    <!-- <el-option label="Todas" :value="null"></el-option> -->
                                    <el-option
                                        v-for="item in functional_areas_for_user"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Nómina" label-width="120px">
                                <el-select multiple v-model="filters.roster_id" filterable placeholder="Seleccione">
                                    <!-- <el-option label="Todas" :value="null"></el-option> -->
                                    <el-option
                                        v-for="item in rosters"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Acuerdo Laboral" label-width="120px">
                                <el-select multiple v-model="filters.labor_agreement_id" filterable placeholder="Seleccione">
                                    <!-- <el-option label="Todos" :value="null"></el-option> -->
                                    <el-option
                                        v-for="item in labor_agreements"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
					<el-row>
                        <el-col :span="8">
                            <el-form-item label="Empleado" label-width="120px" prop="filter">
                                <el-input placeholder="Nombre, Cédula o Código" v-model="filters.filter" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="Fechas" label-width="120px" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                                <el-date-picker
                                    v-model="filters.date_range"
                                    type="daterange"
                                    @change="dateRangePickerChange"
                                    format="yyyy-MM-dd"
                                    :picker-options="{firstDayOfWeek:1}"
                                    start-placeholder="Desde"
                                    end-placeholder="Hasta">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
					<el-row><el-col :span="24" style="text-align: right;">
						<el-form-item v-if="Object.keys(filters).length" style="margin-bottom: 0;">
							<el-button type="primary" @click="handleFilter">Filtrar</el-button>
						</el-form-item>
						<el-form-item v-if="Object.keys(filters).length" style="margin-bottom: 0;">
							<el-button type="info" @click="handleClearFilters">Limpiar</el-button>
						</el-form-item>
					</el-col></el-row>
				</el-form>
			</div>
		</div>
    </div>

</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';
    export default {
        data() {
            return {
                showFilters: true,
                filters: {
                    functional_area_id: [],
                    roster_id: [],
                    labor_agreement_id: [],
                    filter: null,
                    date_range: null,
                    date_from: null,
                    date_to: null,
                },
            }
        },
        computed: {
            ...mapGetters(["functional_areas_for_user", "labor_agreements", "rosters"]),
            'functional_area_name': function () { return getOptionLabel(this.functional_areas_for_user, this.filters.functional_area_id) },
            'roster_name': function () { return getOptionLabel(this.rosters, this.filters.roster_id) },
            'labor_agreement_name':function () { return getOptionLabel(this.labor_agreements, this.filters.labor_agreement_id) },
        },
		watch: {
			'$route': function (to) {
				this.fillFiltersForm(true);
			}
		},
        mounted: function () {
            this.fetchFunctionalAreasForUser();
            this.fetchLaborAgreements();
            this.fetchRosters();
            this.fillFiltersForm(true);
        },
        methods: {
            ...mapActions(["fetchFunctionalAreasForUser", "fetchLaborAgreements", "fetchRosters"]),
            fillFiltersForm: function (emit = false) {
				_.each(this.filters, (value, key) => {
					// console.log(key);
					// console.log(this.$route.query[key]);
					if (this.$route.query[key] != undefined && this.$route.query[key] != null) {
                        if ((key == 'functional_area_id' || key == 'roster_id' || key == 'labor_agreement_id')  && !Array.isArray(this.$route.query[key])) {
                            this.filters[key] = [this.$route.query[key]];
                        } else {
                            this.filters[key] = this.$route.query[key];
                        }
					} else if (key == 'functional_area_id' || key == 'roster_id' || key == 'labor_agreement_id'){
                        this.filters[key] = [];
                    } else {
						// _.each(this.filters, (elem, idx) => {
						// 	if (elem.id == key && elem.mandatory)
						// 		this.filtersValid = false;
						// });
						this.filters[key] = null;
					}
                });
                if (this.filters.date_from != null && this.filters.date_to) {
                    this.filters.date_range = [
                        moment.parseZone(this.filters.date_from),
                        moment.parseZone(this.filters.date_to)
                    ];
                }
                if (emit) {
                    this.$nextTick(() => {
                        if (this.$refs['filtersForm']) {
                            this.$refs['filtersForm'].validate((valid) => {
                                if (valid) {
                                    this.showFilters = false;
                                    this.$emit('filtersSubmited', {...this.filters, valid: true});
                                } else {
                                    this.showFilters = true;
                                    this.$emit('filtersSubmited', {...this.filters, valid: false});
                                }
                            });
                        } else {
                            const isValid = !!(this.filters.date_from && this.filters.date_to);
                            this.$emit('filtersSubmited', {...this.filters, valid: isValid});
                        }
                    });
                }
            },
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
            handleFilter: function () {
				this.$refs['filtersForm'].validate((valid) => {
					if (valid) {
		            	let query = {page: 1};
						_.each(this.filters, (value, key) => {
							if (value != null && key != 'date_range'){
								query[key] = value; //this.filters[key];
							}
						});
						this.showFilters = false;
						this.$router.push({path: this.resourceUrl, query});
						this.$emit('filtersSubmited', {...this.filters, valid: true});
					} else {
						return false;
					}
				});
            },
            handleClearFilters: function () {
				this.data = [];
				this.pagination = {
					current_page: null,
					from: null,
					last_page: null,
					next_page_url: null,
					per_page: null,
					prev_page_url: null,
					to: null,
					total: null
				};
            	let query = {page: 1};
				_.each(this.filters, (value, key) => {
					this.filters[key] = null;
				});
				this.$router.push({path: this.resourceUrl, query});
            },
        }
    }
</script>
